import React, {useEffect} from 'react';
import {Box, Pagination} from '@mui/material';
import {useDispatch, useSelector} from 'react-redux';
import {getCheckins} from '../actions';
import CheckinsTable from '../components/CustomTables/CheckinsTable';
import {Filters} from '../components';
import useFilters from '../utils/useFilters';
import { getCheckinsByCustomer } from '../actions/reportsActions';

const CustomersCheckinsPage = ({customerId}) => {
  const dispatch = useDispatch();
  // const {checkins, checkinsPage, checkinsTotalPages, reportsLoading} =
  //   useSelector(s => s.reports);
  const {customerCheckins, customerCheckinsPage, customerCheckinsTotalPages, customerCheckinsLoading} =
    useSelector(s => s.reports);
    const filters = useFilters(val => dispatch(getCheckinsByCustomer(customerId, val)), 'imei');

  const onPageChange = (e, value) => {
    dispatch(getCheckinsByCustomer(customerId, {page: value, ...filters.filters}));
  };

  useEffect(() => {
    dispatch(getCheckinsByCustomer(customerId));
  }, [dispatch, customerId]);

  console.log("check checkings", customerCheckins);

  return (
    <>
      <Filters
        withSearch
        withDateRange
        searchLabel="Search by IMEI"
        {...filters}
      />
      <CheckinsTable checkins={customerCheckins} loading={customerCheckinsLoading} />
      {customerCheckinsTotalPages > 1 && (
        <Box mt="1rem" display="flex" justifyContent="center">
          <Pagination
            count={customerCheckinsTotalPages}
            page={customerCheckinsPage}
            onChange={onPageChange}
          />
        </Box>
      )}
    </>
  );
};

export default CustomersCheckinsPage;
